import ButtonLogoutModal from './ButtonLogoutModal';

export default ButtonLogoutModal;
